import { env } from "../config";

export function useEnvConfig(optName: string): string {
  return env[`REACT_APP_${optName}`] || "";
}
